import React, { useState } from 'react';
import './LoginForm.css'; // reuse existing login styles
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    // ✅ Skip backend call for now
    setSent(true);
    setMessage("⚠️ This feature will be available in a future update.");
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <div className="back-button" onClick={() => navigate(-1)}>
          <span className="arrow">←</span> Back
        </div>

        <h2>Forgot Password</h2>
        <p>Enter your registered email to receive a reset link.</p>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Email ID</label>
            <div className="input-icon">
              <i className="fa fa-envelope"></i>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                disabled={sent}
              />
            </div>
          </div>

          {!sent && <button type="submit" className="login-btn">Send Reset Link</button>}

          {message && (
            <p style={{
              marginTop: '1rem',
              fontWeight: 'bold',
              color: 'orange'
            }}>
              {message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
